import { ThemeConfig } from 'antd';
import { colors, semanticColors, darkColors, darkSemanticColors } from './colors';

// Note: ThemeMode ('light' | 'dark' | 'system') is defined in ThemeContext
// This type represents the resolved theme after system preference is applied
export type ThemeName = 'light' | 'dark';

export const lightTheme: ThemeConfig = {
  token: {
    colorPrimary: colors.primary.main,
    colorSuccess: colors.success.main,
    colorWarning: colors.warning.main,
    colorError: colors.danger.main,
    colorInfo: colors.info.main,
    colorTextBase: colors.text.primary,
    colorTextSecondary: colors.text.secondary,
    colorBorder: colors.border.accent,
    colorText: colors.text.primary,
    colorBgSpotlight: colors.primary.spotlight,
    fontFamily: 'Work Sans',
    controlHeight: 40,
    borderRadiusLG: 20,
  },
  components: {
    Card: {
      colorBorderSecondary: colors.border.secondary,
    },
    Button: {
      fontWeight: 500,
      paddingContentHorizontal: 24,
    },
    Form: {
      itemMarginBottom: 32,
    },
    Menu: {
      itemColor: semanticColors.menu.item,
      itemHoverColor: semanticColors.menu.itemHover,
      itemSelectedColor: semanticColors.menu.itemSelected,
      itemSelectedBg: semanticColors.menu.selectedBackground,
      itemHoverBg: '#00000005',
      itemActiveBg: '#00000010',
      activeBarBorderWidth: 2,
    },
    Table: {
      headerBg: colors.primary.tint,
    },
    Tooltip: {
      colorTextLightSolid: colors.purple.main,
    },
    Select: {
      multipleItemBg: colors.purple.light,
    },
  },
};

export const darkTheme: ThemeConfig = {
  token: {
    colorPrimary: darkColors.primary.main,
    colorSuccess: darkColors.success.main,
    colorWarning: darkColors.warning.main,
    colorError: darkColors.danger.main,
    colorInfo: darkColors.info.main,
    colorTextBase: darkColors.text.primary,
    colorTextSecondary: darkColors.text.secondary,
    colorBorder: darkColors.border.accent,
    colorText: darkColors.text.primary,
    colorBgSpotlight: darkColors.primary.spotlight,
    colorBgContainer: darkColors.background.surface,
    colorBgElevated: darkColors.background.secondary,
    colorBgLayout: darkColors.background.main,
    fontFamily: 'Work Sans',
    controlHeight: 40,
    borderRadiusLG: 20,
  },
  components: {
    Card: {
      colorBorderSecondary: darkColors.border.secondary,
      colorBgContainer: darkColors.card.background,
    },
    Button: {
      fontWeight: 500,
      paddingContentHorizontal: 24,
    },
    Form: {
      itemMarginBottom: 32,
    },
    Menu: {
      itemColor: darkSemanticColors.menu.item,
      itemHoverColor: darkSemanticColors.menu.itemHover,
      itemSelectedColor: darkSemanticColors.menu.itemSelected,
      itemSelectedBg: darkSemanticColors.menu.selectedBackground,
      itemHoverBg: '#FFFFFF08',
      itemActiveBg: '#FFFFFF10',
      activeBarBorderWidth: 2,
      colorBgContainer: darkColors.background.secondary,
    },
    Table: {
      headerBg: darkColors.primary.tint,
      colorBgContainer: darkColors.background.surface,
    },
    Tooltip: {
      colorTextLightSolid: darkColors.purple.main,
    },
    Select: {
      multipleItemBg: darkColors.purple.light,
      colorBgContainer: darkColors.background.surface,
      colorBgElevated: darkColors.background.secondary,
    },
    DatePicker: {
      colorBgContainer: darkColors.background.surface,
      colorBgElevated: darkColors.background.secondary,
    },
    Modal: {
      contentBg: darkColors.card.background,
      headerBg: darkColors.card.background,
      titleColor: darkColors.text.primary,
      colorText: darkColors.text.primary,
    },
    Input: {
      colorBgContainer: darkColors.card.background,
      colorText: darkColors.text.primary,
      colorTextPlaceholder: darkColors.text.muted,
    },
    Progress: {
      remainingColor: darkColors.border.main,
    },
  },
};
